import vxMysteryHeader from '../vx-mystery-header/vx-mystery-header.vue';
import vxMysteryFooter from '../vx-mystery-footer/vx-mystery-footer.vue';
import vxMysteryOfferOptInMixin from './vx-mystery-offer-opt-in-mixin';

export default {
  name: 'vx-mystery-opt-in',
  components: { vxMysteryHeader, vxMysteryFooter },
  data() {
    return {
      title: 'Opt in page',
      submitButtonText: 'SUBMIT',
    };
  },
  mixins: [vxMysteryOfferOptInMixin],
};



// WEBPACK FOOTER //
// ./src/marketingpages/components/vx-mystery-offer-opt-in/vx-mystery-offer-opt-in.js